var iconResizeTimeout;

function resizeFontIcons(): void {
  document.querySelectorAll('.fa-icon').forEach(x => {
    let div = x.closest('div') as HTMLElement;
    if (div) {
      let divHeight = div.offsetHeight;
      (x as HTMLElement).style.fontSize = `${divHeight / 2}px`;
    }
  });
}

function delayResizeFontIcons(): void {
  clearTimeout(iconResizeTimeout);
  iconResizeTimeout = setTimeout(function () {
    resizeFontIcons();
  }, 250);
}


document.addEventListener('DOMContentLoaded', () => {
  resizeFontIcons();
});

// Run on resize
window.addEventListener('resize', () => {
  resizeFontIcons();
});

// Re-run on DOM changes
let iconObserver = new MutationObserver(() => {
  delayResizeFontIcons(); // short wait to avoid multiple calls when multiple DOM changes occur in quick succession
});
iconObserver.observe(document.body, {
  characterDataOldValue: true,
  subtree: true,
  childList: true,
  characterData: true
});

// Re-run whenever elements are shown via intersection observer
// This triggers when an icon scrolls into view, or when it becomes visible within the viewport
const fontIconIntersectionObserver = new IntersectionObserver(resizeFontIcons);
document.querySelectorAll('.fa-icon').forEach(x => {
  fontIconIntersectionObserver.observe(x);
});
